module.exports = [{
  title: `Basalt Crux`,
  image: `basalt-tokens.png`,
  ds: {
    site: `https://design.basalt.io`,
    source: `https://github.com/basaltinc/crux`
  },
  token: {
    site: `https://design.basalt.io/design-tokens/all-tokens`,
    source: ``
  },
},{
  title: `Bitnami HEx`,
  image: `bitnami-tokens.png`,
  ds: {
    site: `https://design.bitnami.com`,
  },
  token: {
    site: `https://design.bitnami.com/category/Design-Tokens`,
  },
},{
  title: `Bloomberg BNA Fishtank`,
  image: `bloomberg-tokens.png`,
  ds: {
    site: `https://fishtank.bna.com/`,
  },
  token: {
    source: `https://github.com/bloombergbna/fishtank-colors`,
  },
},{
  title: `Discover Comet`,
  image: `discover-comet.png`,
  ds: {
    site: `https://comet.discoveryeducation.com`,
  },
  token: {
    site: `https://comet.discoveryeducation.com/visual-language/tokens.html`,
  },
},{
  title: `Envato Foundation`,
  image: `envato-tokens.png`,
  ds: {
    site: `https://envato.github.io/foundation-design-system`,
  },
  token: {
    site: `https://envato.github.io/foundation-design-system/design-tokens`,
    source: `https://github.com/envato/foundation-design-system-tokens`,
  },
},{
  title: `Formstack`,
  image: `formstack-tokens.png`,
  ds: {
    site: `https://www.formstack.com/brand/design-system`,
  },
  token: {
    site: `https://www.formstack.com/brand/design-system/tokens`,
    source: ``,
  },
},{
  title: `Infor`,
  image: `infor-tokens.png`,
  ds: {
    site: `https://design.infor.com`,
    source: `https://github.com/infor-design/design-system`,
  },
  token: {
    site: `https://design.infor.com/guidelines/identity/design-tokens`,
    source: ``,
  },
},{
  title: `Kalo`,
  image: `kalo-tokens.png`,
  ds: {
    site: `https://kalo.design`,
    source: ``,
  },
  token: {
    site: `https://kalo.design/foundations/design-tokens`,
    source: ``,
  },
},{
  title: `Kiwi Orbit`,
  image: `kiwi-tokens.png`,
  ds: {
    site: `https://orbit.kiwi`,
    source: `https://github.com/kiwicom/orbit-components`,
  },
  token: {
    site: `https://orbit.kiwi/design-tokens`,
    source: `https://github.com/kiwicom/orbit-design-tokens`,
  },
},{
  title: `Meetup Swarm`,
  image: `meetup-tokens.png`,
  ds: {
    site: `https://meetup.github.io/swarm-design-system`,
    source: ``,
  },
  token: {
    site: `https://meetup.github.io/swarm-constants`,
    source: `https://github.com/meetup/swarm-constants`,
  },
},{
  title: `Mineral UI`,
  image: `mineral-tokens.png`,
  ds: {
    site: `https://mineral-ui.com`,
    source: `https://github.com/mineral-ui/mineral-ui`,
  },
  token: {
    site: `https://mineral-ui.com/tokens`,
    source: `https://github.com/mineral-ui/mineral-ui/tree/master/packages/mineral-ui-tokens`,
  },
},{
  title: `Mozilla Protocol`,
  image: `mozilla-protocol.png`,
  ds: {
    site: `https://protocol.mozilla.org`,
    source: `https://github.com/mozilla/protocol`,
  },
  token: {
    site: `https://protocol.mozilla.org/fundamentals/tokens.html`,
    source: `https://github.com/mozilla/protocol-tokens`,
  },
},{
  title: `Owncloud`,
  image: `owncloud-tokens.png`,
  ds: {
    site: `https://owncloud.github.io/owncloud-design-system`,
    source: `https://github.com/owncloud/owncloud-design-system`,
  },
  token: {
    site: `https://owncloud.github.io/owncloud-design-system/#/Design%20Tokens`,
  },
},{
  title: `Open Table Design Bar`,
  image: `opentable-design-bar.png`,
  ds: {},
  token: {
    site: `https://opentable.github.io/design-tokens/`,
    source: `https://github.com/opentable/design-tokens`,
  },
},{
  title: `REI Cedar`,
  image: `rei-cedar.png`,
  ds: {
    site: `https://rei.github.io/rei-cedar-docs`,
    source: `https://github.com/rei/rei-cedar-docs`,
  },
  token: {
    site: `https://rei.github.io/rei-cedar-tokens`,
    source: `https://github.com/rei/rei-cedar-tokens`,
  },
},{
  title: `Salesforce Lightning`,
  image: `salesforce-tokens.png`,
  ds: {
    site: `https://www.lightningdesignsystem.com`,
    source: `https://github.com/salesforce-ux/design-system`,
  },
  token: {
    site: `https://www.lightningdesignsystem.com/design-tokens`,
  },
},{
  title: `Shopify Polaris Icons`,
  image: `shopify-polaris-icons.png`,
  ds: {},
  token: {
    site: `https://polaris-icons.shopify.com`,
  },
},{
  title: `Skyscanner Backpack`,
  image: `backpack-tokens.png`,
  ds: {
    site: `https://backpack.github.io`,
    source: `https://github.com/Skyscanner/backpack-docs`,
  },
  token: {
    site: `https://backpack.github.io/tokens`,
    source: `https://github.com/backpack/tokens`,
  },
},{
  title: `Sprout Social Seeds`,
  image: `sprout-tokens.png`,
  ds: {
    site: `https://sproutsocial.com/seeds`,
  },
  token: {
    site: `https://sproutsocial.com/seeds/resources/tokens`,
    source: `https://github.com/sproutsocial/seeds-packets`,
  },
},{
  title: `Thumbprint`,
  image: `thumbprint-tokens.png`,
  ds: {
    site: `https://thumbprint.design`,
    source: `https://github.com/thumbtack/thumbprint`
  },
  token: {
    site: `https://thumbprint.design/tokens`,
  },
},{
  title: `Udacity Veritas`,
  image: `udacity-tokens.png`,
  ds: {
    site: `https://veritas.udacity.design`,
  },
  token: {
    site: `https://veritas.udacity.design/tokens`,
  },
},{
  title: `Hudl Uniform`,
  image: `hudl-uniform-tokens.png`,
  ds: {
    site: `http://uniform.hudl.com`,
  },
  token: {},
},{
  title: `US Web Design System`,
  image: `us-web-design-system-tokens.png`,
  ds: {
    site: `https://designsystem.digital.gov`,
    source: `https://github.com/uswds/uswds`,
  },
  token: {
    site: `https://designsystem.digital.gov/design-tokens`,
  },
}]